import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Const from "../../const";
import {
    calcShippingDataAsync,
    createOrderAwaitAsync, createOrderAwaitAtCloudFlareWorker,
    getYIdPw, getYOrder,
    getYToken, putYLog,
    putYOrder,
    saveYToken, Y_LOG_ACTION_CODE,
    yogiyoLogin,
    yogiyoOrderInfo, yogiyoOrderList
} from "../../api/api";
import {yWebsockConnected, yWebsockDisconnected} from "../../actions/yWebsockAction";
import {reactLocalStorage} from "reactjs-localstorage";
import {Button} from "antd";
import {allCategoryCode} from "../../lib/util/codeUtil";
import moment from "moment";
import {httpPost, httpUrl} from "../../api/httpClient";

let url = null;
let yToken = null;
let wsTimecheckWSInterval = null;
let wsPingInterval = null;
let wsPollingInterval = null;

const wsReadyState = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
};

const YWebSocket = () => {
    const yWebsockIsConnected = useSelector(state => state.yWebsock.isConnected);
    const flag = useSelector(state => state.yWebsock.flag);

    const loginInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    // const loginInfo = useSelector(state => state.loginReducer.loginInfo);

    const dispatch = useDispatch();

    const initWs = () => {
        console.log("===== init YWebSocket =====");
        if (global.yWs != null) {
            console.log('yWs is not null');
            global.yWs.close();
            global.yWs = null;
        }
        global.yWs = new WebSocket(url);
        global.yWs.onopen = () => {
            console.log("yWs open");
            try {
                putYLog({
                    action:Y_LOG_ACTION_CODE.Y_WS_ONOPEN,
                    code:null,
                    data:null,
                    result:null,
                });
            } catch (e) {}
            dispatch(yWebsockConnected());
        }

        global.yWs.onmessage = async (e) => {
            console.log("websocket message", e);
            const dataJson = e.data;
            try {
                const data = JSON.parse(dataJson);
                try {
                    putYLog({
                        action:Y_LOG_ACTION_CODE.Y_WS_ONMESSAGE,
                        code:null,
                        data,
                        result:null,
                    });
                } catch (e) {}
                const keys = Object.keys(data);
                if (!keys.includes('type') || !keys.includes('orderId')) {
                    console.error(`Invalid yWebsock message data ${data}`);
                    return;
                } else {
                    console.log(data);
                    await handleYWsMessage(data);
                }
            } catch (e) {
                console.error(`Error while parsing yWebsock data : ${dataJson}`, e);
                return;
            }
        }

        global.yWs.onerror = (e) => {
            console.error(`yWs onerror. message : ${e.message}`);
            try {
                putYLog({
                    action: Y_LOG_ACTION_CODE.Y_WS_ONERROR,
                    code: e?.code,
                    data: e,
                    result: e?.message,
                });
            } catch (e) {
            }
        }

        global.yWs.onclose = (e) => {
            console.log(`yWs onclose. code : ${e.code}, reason : ${e.reason}`);
            try {
                putYLog({
                    action: Y_LOG_ACTION_CODE.Y_WS_ONCLOSE,
                    code: e?.code,
                    data: e,
                    result: e?.reason,
                });
            } catch (e) {
            }

            dispatch(yWebsockDisconnected());
        }
    }

    const checkWS = () => {
        if (global.yWs === null || typeof global.yWs === 'undefined') {
            console.log(`ywsTimeInterval. yws invalid type. type: ${typeof global.yWs}`);
            return;
        }
        if (global.yWs.readyState !== wsReadyState.OPEN) {
        }
        if (global.yWs.readyState === wsReadyState.CLOSED) {
            global.yWs = null;
            initWs();
        }
    };

    const handleYWsMessage = async (data) => {
        console.log('handleYWsMessage yToken', yToken);
        if (null === yToken || undefined === yToken) return;

        const orderInfo = await yogiyoOrderInfo(data.orderId, yToken);
        console.log("yogiyo orderinfo : ", orderInfo);

        // 개발 테스트 시 주석처리
        // 요기요 익스프레스 주문 제외 처리
        // 2/3 state 및 transport 확인
        if (
            orderInfo?.state === null
            || orderInfo?.state === undefined
            || orderInfo.state !== 'ACCEPTED'
            || null === orderInfo?.transport
            || undefined === orderInfo?.transport
            || orderInfo.transport?.type === null
            || orderInfo.transport?.type === undefined
            || orderInfo.transport.type !== 'RESTAURANT_DELIVERY'
        ) return;
        // 1시간 넘은 주문 제외처리 (웹소켓으로 오래된 예전 주문이 들어오는 경우가 있다고 함)
        if (orderInfo?.timestamp === null || orderInfo?.timestamp === undefined) return;
        const orderTimestamp = new moment(orderInfo?.timestamp);
        const now = new moment();
        // diff 시간단위를 hour로 하면 1~2시간 사이가 1로 반환됨
        const diffAbs = Math.abs(now.diff(orderTimestamp, 'minutes'));
        if (diffAbs > 60) return;

        const orderAwaitRes = await httpPost(httpUrl.getOrderAwaitList, [], {});
        console.log('orderAwaitRes : ', orderAwaitRes);
        if (
            orderAwaitRes?.data === undefined
            || orderAwaitRes?.data?.orderAwaitList === undefined
            || !Array.isArray(orderAwaitRes?.data?.orderAwaitList)
        ) return;

        const orderAwaitList = orderAwaitRes.data.orderAwaitList;
        // 4. 이미 등록된 대기주문인지 확인
        const prev = orderAwaitList.find(orderAwaitJSON => {
            const orderAwait = JSON.parse(orderAwaitJSON);
            if (
                orderAwait?.orderCode === null
                || orderAwait?.orderCode === undefined
                || orderAwait?.memo === null
                || orderAwait?.memo === undefined
                || orderAwait?.memo === ""
            ) return false;
            if (orderAwait.memo === orderInfo.id) return true;
        });
        if (prev !== null && prev !== undefined) {
            console.log('이미 등록된 대기주문 : ', prev);
            return;
        }
        // 5. yOrder api 에 등록된 주문인지 확인
        if (orderInfo?.id === undefined) return;
        const getYOrderRes = await getYOrder(orderInfo?.id);
        if (
            getYOrderRes === null
            || getYOrderRes?.value !== null
        ) {
            console.log("yOrder에 이미 등록된 주문", getYOrderRes);
            return;
        }

        const metaData = {
            branchIdx: loginInfo?.branchIdx,
            frId: loginInfo?.id,
            yOrderId: data.orderId,
        }
        const res = await putYOrder({
            yOrder: orderInfo,
            metaData,
            ...metaData,
        });

        if (null === res || res.result !== 'success') return;

        let orderAwait = res.nOrder;
        orderAwait.orderCode = 'y' + orderAwait.orderCode;
        orderAwait.custPhone = orderAwait.phone || '';
        orderAwait.orderPrice = orderAwait.price || 0;
        orderAwait.orderPayments = [{
            paymentMethod: orderAwait.paymentMethod,
            paymentAmount: orderAwait.price,
            paymentStatus: 1
        }];

        const deliveryPriceRes = await calcShippingDataAsync(orderAwait.destAddr1, orderAwait.destAddr3);
        console.log('y websocket deliveryPriceRes', deliveryPriceRes);
        // 배달비 계산 실패해도 대기주문은 등록되게 해주는게 낫지 않을까?
        if (deliveryPriceRes !== null) {
            orderAwait.basicDeliveryPrice = deliveryPriceRes.deliveryBasicPrice;
            orderAwait.extraDeliveryPrice = deliveryPriceRes.deliveryAddPrice;
        }

        try {
            await createOrderAwaitAsync(orderAwait);//TODO ojoomi #6682일감에 따라 d1 정식배포전까지 대기주문 생성은 기존 redis에 write하도록 변경
            /*await createOrderAwaitAtCloudFlareWorker(orderAwait); // 대기주문 redis => clf d1으로 관리하도록 변경*/
            putYLog({
                action: Y_LOG_ACTION_CODE.CONVERT_Y_ORDER_TO_NN_ORDER,
                code: null,
                data: {orderAwait},
                result: '성공',
            })
        } catch (e) {
            putYLog({
                action: Y_LOG_ACTION_CODE.CONVERT_Y_ORDER_TO_NN_ORDER,
                code: null,
                data: {orderAwait, error: e.response.data},
                result: '실패',
            })
        }
    }

    const sendWebsocketPing = () => {
        try {
            const yWs = global.yWs;
            if (undefined === yWs || null === yWs) {
                return;
            }

            if ('function' === typeof yWs.send) {
                yWs.send('P');
            }

            try {
                putYLog({
                    action:Y_LOG_ACTION_CODE.Y_WS_PING,
                    code:null,
                    data:{ readyState:global?.yWs?.readyState },
                    result:null,
                });
            } catch (e) {}

        } catch (e) {
        }
    }

    const pollingYogiyoOrder = async () => {
        console.log('===== pollingYogiyoOrder =====');
        const now = new moment();
        console.log(encodeURI(now.toISOString()));
        let res = null;
        try {
            res = await yogiyoOrderList({
                from: encodeURI(now.clone().subtract(1, 'hours').toISOString()),
                to: encodeURI(now.toISOString()),
            }, yToken);
            putYLog({
                action: Y_LOG_ACTION_CODE.Y_ORDER_POLLNG,
                code: null,
                data: {response: res, token: yToken},
                result: '성공',
            });
        } catch (e) {
            putYLog({
                action: Y_LOG_ACTION_CODE.Y_ORDER_POLLNG,
                code: null,
                data: {response: res, token: yToken, error: e.response.data},
                result: '실패',
            });
        }

        // 테스트 코드 ( 실서버 주문정보 )
        // const res = [{
        //     externalId:"F2308111529JFSF2",
        //     id:"oma_3ab6147e-25a0-5d4e-8127-6a24ff246b72",
        //     state:"ACCEPTED",
        //     timestamp:"2023-08-16T00:30:25.663Z",
        //     vendorTimeZone:"Asia/Seoul",
        //     transport:{type: 'RESTAURANT_DELIVERY', deliverTime: '2023-08-11T07:00:39.211Z'},
        // }];
        console.log("yogiyoOrderList res : ", res);

        if (res === null || res === undefined || !Array.isArray(res)) return;
        const orderAwaitRes = await httpPost(httpUrl.getOrderAwaitList, [], {});
        console.log('orderAwaitRes : ', orderAwaitRes);
        if (
            orderAwaitRes?.data === undefined
            || orderAwaitRes?.data?.orderAwaitList === undefined
            || !Array.isArray(orderAwaitRes?.data?.orderAwaitList)
            ) return;

        const orderAwaitList = orderAwaitRes.data.orderAwaitList;
        for (let i = 0; i < res.length; i++) {
            const yOrder = res[i];
            // 1. 1시간 지난 주문 제외
            const orderTimestamp = new moment(yOrder?.timestamp);
            const now = new moment();
            console.log("orderTimestamp / now : ", orderTimestamp, now);

            // diff 시간단위를 hour로 하면 1~2시간 사이가 1로 반환됨
            const diffAbs = Math.abs(now.diff(orderTimestamp, 'minutes'));
            if (diffAbs > 60) {
                console.log("1시간 지난 주문 diffAbs : ", diffAbs);
                return;
            }
            // 2. state 확인
            if (yOrder?.state !== "ACCEPTED") {
                console.log("state 가 ACCEPTED 아닌 주문 : ", yOrder?.state);
                return;
            }
            // 3. transport 확인 (요기요 익스프레스 주문 제외 작업)
            if (yOrder?.transport === undefined || yOrder?.transport?.type !== 'RESTAURANT_DELIVERY') {
                console.log("한집배달 주문 제외 조건 : ", yOrder?.transport?.type);
                return;
            }
            // 4. 이미 등록된 대기주문인지 확인
            const prev = orderAwaitList.find(orderAwaitJSON => {
                const orderAwait = JSON.parse(orderAwaitJSON);
                if (
                    orderAwait?.orderCode === null
                    || orderAwait?.orderCode === undefined
                    || orderAwait?.memo === null
                    || orderAwait?.memo === undefined
                    || orderAwait?.memo === ""
                ) return false;
                if (orderAwait.memo === yOrder.id) return true;
            });
            if (prev !== null && prev !== undefined) {
                console.log('이미 등록된 대기주문 : ', prev);
                return;
            }
            // 5. yOrder api 에 등록된 주문인지 확인
            if (yOrder?.id === undefined) return;
            const getYOrderRes = await getYOrder(yOrder?.id);
            if (
                getYOrderRes === null
                || getYOrderRes?.value !== null
            ) {
                console.log("yOrder에 이미 등록된 주문", getYOrderRes);
                return;
            }

            // 모든 조건 다 통과한 주문 대기 주문 생성
            const orderInfo = await yogiyoOrderInfo(yOrder.id, yToken);
            console.log("yogiyo orderinfo : ", orderInfo);

            // 개발 테스트 시 주석처리
            if (
            orderInfo?.state !== 'ACCEPTED'
            || null === orderInfo?.transport
            || undefined === orderInfo?.transport
            || null === orderInfo?.transport?.type
            || undefined === orderInfo?.transport?.type
            || orderInfo?.transport?.type !== 'RESTAURANT_DELIVERY'
            ) {
                console.log("orderInfo.state !== 'ACCEPTED' || null === orderInfo.transport || undefined === orderInfo?.transport || null === orderInfo?.transport?.type || undefined === orderInfo?.transport?.type || orderInfo.transport.type !== 'RESTAURANT_DELIVERY'"
                    , orderInfo.state !== 'ACCEPTED'
                    , null === orderInfo.transport
                    , undefined === orderInfo?.transport
                    , null === orderInfo?.transport?.type
                    , undefined === orderInfo?.transport?.type
                    , orderInfo?.transport?.type !== 'RESTAURANT_DELIVERY');
                return;
            }

            const metaData = {
                branchIdx: loginInfo?.branchIdx,
                frId: loginInfo?.id,
                yOrderId: yOrder.id,
            }
            const putYOrderRes = await putYOrder({
                yOrder: orderInfo,
                metaData,
                ...metaData,
            });

            if (null === putYOrderRes || putYOrderRes.result !== 'success') return;

            let orderAwait = putYOrderRes.nOrder;
            orderAwait.orderCode = 'y' + orderAwait.orderCode;
            orderAwait.custPhone = orderAwait.phone || '';
            orderAwait.orderPrice = orderAwait.price || 0;
            orderAwait.orderPayments = [{
                paymentMethod: orderAwait.paymentMethod,
                paymentAmount: orderAwait.price,
                paymentStatus: 1
            }];

            const deliveryPriceRes = await calcShippingDataAsync(orderAwait.destAddr1, orderAwait.destAddr3);
            // 배달비 계산 실패해도 대기주문은 등록되게 해주는게 낫지 않을까?
            if (deliveryPriceRes !== null) {
                orderAwait.basicDeliveryPrice = deliveryPriceRes.deliveryBasicPrice;
                orderAwait.extraDeliveryPrice = deliveryPriceRes.deliveryAddPrice;
            }

            try {
                await createOrderAwaitAsync(orderAwait);// TODO ojoomi #6682일감에 따라 d1 정식배포전까지 대기주문 생성은 기존 redis에 write하도록 변경
                /*await createOrderAwaitAtCloudFlareWorker(orderAwait); // 대기주문 redis => clf d1으로 관리하도록 변경*/
                putYLog({
                    action: Y_LOG_ACTION_CODE.CONVERT_Y_ORDER_TO_NN_ORDER,
                    code: null,
                    data: {orderAwait},
                    result: '성공',
                })
            } catch (e) {
                putYLog({
                    action: Y_LOG_ACTION_CODE.CONVERT_Y_ORDER_TO_NN_ORDER,
                    code: null,
                    data: {orderAwait, error: e.response.data},
                    result: '실패',
                })
            }

        }
    }

    useEffect(async () => {
        const reqData = {
            branchIdx: loginInfo?.branchIdx,
            frId: loginInfo?.id,
        };

        const res = await getYIdPw(reqData);
        if (!res.value) return;

        // 조회된 yId/yPw로 요기요 로그인 (yToken 발급)
        const yogiyoLoginRes = await yogiyoLogin({username: res.value.yId, password: res.value.yPw});
        console.log('yogiyoLoginRes', yogiyoLoginRes);
        if (!yogiyoLoginRes) return;

        // 발급받은 token yToken으로 저장
        await saveYToken({
            ...reqData,
            ...yogiyoLoginRes,
        });
        const yTokenRes = await getYToken(reqData);
        console.log('yTokenRes : ', yTokenRes);
        if (null === yTokenRes) return;

        yToken = yogiyoLoginRes?.token;

        if (Const.yWebsockUrl === "nnbox-ws.nyamnyambox.com/ws") {
            // 내부 테스트용과 실서버 url의 구조가 다름
            // 내부 테스트용 url
            url = `${Const.wsProtocol}://${Const.yWebsockUrl}`;
        } else if (Const.yWebsockUrl === "ps.rpsyogiyo.io") {
            url = `${Const.wsProtocol}://${Const.yWebsockUrl}?token=${yogiyoLoginRes?.token}&deviceUuid=${encodeURIComponent(yTokenRes?.metadata?.deviceUuid)}`;
            console.log(url);
        } else return;

        initWs();
        wsTimecheckWSInterval = setInterval(() => {
            checkWS();
        }, 1000);
        wsPingInterval = setInterval(() => {
            sendWebsocketPing();
        }, res.value?.y웹소켓_핑_간격_분 ? res.value?.y웹소켓_핑_간격_분 * 60000 : 480000);

        // 폴링여부 관계없이 처음 접속할때 한번은 기존 주문목록 불러오기
        await pollingYogiyoOrder();
        if (
            res?.value !== null
            && res?.value !== undefined
            && res?.value?.y주문_폴링_간격_분 !== null
            && res?.value?.y주문_폴링_간격_분 !== undefined
            && res?.value?.y주문_폴링_간격_분 !== 0
        ) {
            wsPollingInterval = setInterval(async () => {
                await pollingYogiyoOrder();
            },
        res?.value?.y주문_폴링_간격_분 * 60000
               // 6000
            )
        }

        return () => {
            if (wsTimecheckWSInterval !== null) clearInterval(wsTimecheckWSInterval);
            if (wsPingInterval !== null) clearInterval(wsPingInterval);
            if (wsPollingInterval !== null) clearInterval(wsPollingInterval);
        }
    }, [flag]);

    return <></>
};

export default YWebSocket;
